export default __webpack_public_path__ + "static/media/dbd_primary.c4438461.svg";